import { Quote } from "lucide-react";

type Props = {
  /** The lyrics text this anchor references */
  anchorText: string;
  /** Called when the chip is clicked to scroll/highlight the lyrics */
  onClick?: (anchorText: string) => void;
};

/**
 * A clickable chip that references specific lyrics text.
 * Rendered from parsed {@"text"} markup in feedback.
 * Clicking scrolls to and highlights the referenced lyrics.
 */
export function LyricsAnchorChip({ anchorText, onClick }: Props) {
  return (
    <button
      type="button"
      onClick={() => onClick?.(anchorText)}
      className="inline-flex items-center gap-1 rounded-full bg-amber/10 px-2 py-0.5 align-middle text-xs font-medium text-amber transition-colors hover:bg-amber/20"
      title={`Jump to "${anchorText}" in lyrics`}
      aria-label={`Jump to lyrics: ${anchorText}`}
    >
      <Quote className="h-3 w-3" aria-hidden="true" />
      <span className="max-w-32 truncate">"{anchorText}"</span>
    </button>
  );
}
